import tabSliderBlockMeta from './block.json';
import { tabSliderIcon } from './icons';
import attributeVisibility from '@components/visibility/attributes.json';
import attributeLabel from '@components/block-label/attributes.json';
import { getBlockLabelByName } from '@helpers/utils.js';
import edit from './edit';
import save from './save';
import './style.scss';

const { registerBlockType } = wp.blocks;
const { name, ...settings } = tabSliderBlockMeta;

const attributes = {
  ...settings.attributes,
  ...attributeVisibility,
  ...attributeLabel,
};

registerBlockType(name, {
  ...settings,
  icon: tabSliderIcon,
  attributes,
  edit,
  save,
  __experimentalLabel: (attributes) =>
    getBlockLabelByName(attributes, settings.title),
});
